import { Plus, Trash2, ArrowUp, ArrowDown } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const GROUPS = [
  ['Headline & message', [
    ['title', 'Service name', 40], ['eyebrow', 'Short introduction', 45],
    ['subtitle', 'Tagline', 95], ['intro', 'Introduction', 210, true],
    ['services_heading', 'Services heading', 55],
  ]],
  ['Invitation & contact details', [
    ['bridge', 'Closing line', 95], ['pricing_note', 'Pricing note (optional)', 75],
    ['cta', 'Call to action', 55], ['availability', 'Service area & availability', 55],
    ['phone', 'WhatsApp number', 28], ['website', 'Website', 65], ['email', 'Email', 75],
    ['disclaimer', 'Service scope note', 215, true],
  ]],
];

export const ServiceFlyerFields = ({ content, onChange, disabled }) => {
  const field = (key, value) => onChange({ ...content, [key]: value });
  const service = (index, key, value) => field('services', content.services.map((item, i) => i === index ? { ...item, [key]: value } : item));
  const move = (index, delta) => {
    const items = [...content.services];
    [items[index], items[index + delta]] = [items[index + delta], items[index]];
    field('services', items);
  };
  return (
    <fieldset disabled={disabled} className="min-w-0 space-y-8" data-testid="service-flyer-fields">
      {GROUPS.map(([heading, fields], groupIndex) => <section key={heading} className="border-t border-border pt-5">
        <h2 className="mb-4 text-base font-bold text-primary">{heading}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {fields.map(([key, label, maxLength, multiline]) => <div key={key} className={multiline || key === 'subtitle' ? 'sm:col-span-2' : 'min-w-0'}>
            <Label htmlFor={`flyer-${key}`} className="mb-1.5 block text-xs">{label}</Label>
            {multiline ? <Textarea id={`flyer-${key}`} value={content[key]} maxLength={maxLength} rows={3}
              onChange={(e) => field(key, e.target.value)} data-testid={`flyer-field-${key}`} />
              : <Input id={`flyer-${key}`} value={content[key]} maxLength={maxLength}
                onChange={(e) => field(key, e.target.value)} data-testid={`flyer-field-${key}`} />}
          </div>)}
        </div>
        {groupIndex === 0 && <div className="mt-7">
          <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
            <h2 className="text-base font-bold text-primary">Services <span className="text-xs font-normal text-gray-500" data-testid="flyer-service-count">{content.services.length}/6</span></h2>
            <Button type="button" size="sm" variant="outline" disabled={content.services.length >= 6}
              onClick={() => field('services', [...content.services, { title: 'New service', body: 'Service details' }])} data-testid="flyer-add-service"><Plus className="mr-1 h-4 w-4" />Add</Button>
          </div>
          {content.services.map((item, index) => <div key={index} className="border-t border-border py-4" data-testid={`flyer-service-${index}`}>
            <div className="mb-2 flex items-center justify-between gap-2">
              <Label htmlFor={`flyer-service-title-${index}`}>Service {index + 1}</Label>
              <div className="flex gap-1">
                <Button type="button" variant="ghost" size="icon" title="Move up" aria-label="Move service up" disabled={index === 0} onClick={() => move(index, -1)} data-testid={`flyer-service-up-${index}`}><ArrowUp className="h-4 w-4" /></Button>
                <Button type="button" variant="ghost" size="icon" title="Move down" aria-label="Move service down" disabled={index === content.services.length - 1} onClick={() => move(index, 1)} data-testid={`flyer-service-down-${index}`}><ArrowDown className="h-4 w-4" /></Button>
                <Button type="button" variant="ghost" size="icon" title="Remove service" aria-label="Remove service" disabled={content.services.length <= 4} onClick={() => field('services', content.services.filter((_, i) => i !== index))} data-testid={`flyer-service-remove-${index}`}><Trash2 className="h-4 w-4 text-red-600" /></Button>
              </div>
            </div>
            <Input id={`flyer-service-title-${index}`} value={item.title} maxLength={38} onChange={(e) => service(index, 'title', e.target.value)} data-testid={`flyer-service-title-${index}`} />
            <Label htmlFor={`flyer-service-body-${index}`} className="mb-1 mt-2 block text-xs">Description</Label>
            <Textarea id={`flyer-service-body-${index}`} value={item.body} maxLength={110} rows={2} onChange={(e) => service(index, 'body', e.target.value)} data-testid={`flyer-service-body-${index}`} />
          </div>)}
        </div>}
      </section>)}
      <div className="border-t border-border pt-5">
        <Label htmlFor="flyer-photo" className="mb-2 block">Photograph</Label>
        <select id="flyer-photo" value={content.photo} onChange={(e) => field('photo', e.target.value)} className="w-full rounded-md border border-border bg-white p-2 text-sm" data-testid="flyer-photo">
          <option value="welcome">Pets settling into their new home</option>
          <option value="concierge">Personal pet concierge support</option>
        </select>
      </div>
    </fieldset>
  );
};